import React from 'react';
import { asyncComponent } from 'react-async-component';

export default asyncComponent({
  resolve: () => import(
    /* webpackChunkName: "recent-traveler-activity" */
    /* webpackPreload: true */
    './RecentTravelerActivity.js'
  ),
  LoadingComponent: () => <React.Fragment />,
  serverMode: 'defer'
});
